import { AppNav } from '@/components/AppNav';
import { Footer } from '@/components/Footer';

export function Support() {
  return (
    <div data-name="SUPPORT" className="flex min-h-screen flex-col">
      <AppNav />
      <div className="flex flex-1 flex-col items-center justify-center gap-8 px-4 md:px-0">
        <h1 className="text-4xl font-bold">Support</h1>
        <p className="border-1 rounded-lg border p-6">
          If you have any questions or need help, please contact us at{' '}
          <a href="mailto:support@screen.live">support@happiscreen.com</a>.
        </p>
      </div>
      <Footer />
    </div>
  );
}
